import React, { useEffect, useState } from 'react';
import { CustomInput } from 'reactstrap';
import { makeFirstLetterCapital } from '../../../../helpers/utils';
import { ButtonWithLoadingIcon } from '../../../common/ButtonWithLoadingIcon';
import { CustomCheckBox } from '../../../common/CustomFormComponents';
import '../aboutme.scss';

const AboutMePrefCheckBox = ({
  id,
  value,
  label,
  isChecked,
  onCheckChanged,
  makeFirstCharCapital,
}) => (
  <div className='about-me-pref-checkbox'>
    <div style={{ color: '#2E2B2B' }}>
      <label className={'label-title mr-1'}>{`${label}: `}</label>
      <label className={'label-text'}>
        {makeFirstCharCapital ? makeFirstLetterCapital(value) : value}
      </label>
    </div>
    <CustomCheckBox
      id={id}
      checked={isChecked}
      onCheckChange={(value) => {
        onCheckChanged(value);
      }}
    />
    {/* <CustomInput
      type='checkbox'
      id={id}
      checked={isChecked}
      onChange={(e) => {
        onCheckChanged(e.target.checked);
      }}
    /> */}
  </div>
);

const AboutMeLabel = ({ value, label }) => (
  <div className='about-me-pref-checkbox'>
    <div>
      <label className={'label-title mr-1'}>{`${label}: `}</label>
      <label className={'label-text'}>{makeFirstLetterCapital(value)}</label>
    </div>
  </div>
);

export const AboutMePreferences = ({
  isUpdating,
  onSubmit,
  preferences: preferencesOld,
  selectedUsuallyWears,
}) => {
  const [preferences, setPreferences] = useState(preferencesOld);

  // useEffect(() => {
  //   setPreferences(preferencesOld);
  // }, [preferencesOld]);

  // handlers
  const handleAboutPrefToggle = (index) => {
    let newPreferences = [...preferences];
    newPreferences[index].isChecked = !newPreferences[index].isChecked;
    setPreferences(newPreferences);
  };

  const handleSubmit = (e) => {
    onSubmit(preferences);
  };

  return (
    <>
      <h6
        className='mb-3 text-right'
        style={{
          color: '#2E2B2B',
          fontFamily: 'Brown',
          fontWeight: 500,
          fontSize: 14,
        }}
      >
        Display with your reviews?
      </h6>

      <div className='about-me-prefs' style={{ color: '#2E2B2B' }}>
        {preferences.map((preference, index) => (
          <AboutMePrefCheckBox
            key={`about-pref-${index}`}
            id={`about-pref-${index}`}
            label={preference.label}
            value={preference.value}
            isChecked={preference.isChecked}
            onCheckChanged={(isChecked) => {
              handleAboutPrefToggle(index, isChecked);
            }}
            makeFirstCharCapital={preference.key !== 'username'}
          />
        ))}
      </div>

      <div className='d-flex justify-content-center mt-4'>
        <ButtonWithLoadingIcon
          disabled={isUpdating}
          type='submit'
          loading={isUpdating}
          color='primary'
          size='sm'
          className={'px-5'}
          onClick={handleSubmit}
          height={36}
        >
          UPDATE
        </ButtonWithLoadingIcon>
      </div>
    </>
  );
};
